import { render, staticRenderFns } from "./MembershipFormInfo.vue?vue&type=template&id=488237dc&"
import script from "./MembershipFormInfo.vue?vue&type=script&lang=js&"
export * from "./MembershipFormInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports